import React from 'react';
import GoogleAd from './GoogleAd';
import { AD_SLOTS } from './adConfig';

/**
 * A full-width, responsive horizontal banner ad rendered under the top nav.
 *
 * Intended for narrower viewports (phones/tablets) where the vertical side rails are hidden,
 * so there is always at least one ad slot on small screens. Visibility is controlled with CSS
 * in custom.css (.metadb-banner-ad) � it is hidden at >=1500px where the side rails take over.
 */
export default function BannerAd() {
    return (
        <div className="metadb-banner-ad">
            <GoogleAd
                slot={AD_SLOTS.banner}
                format="auto"
                responsive={true}
                label="Top Banner (responsive)"
                style={{ display: 'block' }}
            />
        </div>
    );
}
